import React from 'react'

import { Accordion } from 'antd-mobile'

import styles from './invoicecomponent.module.css'
import { getFirstWord } from '../ShareUtils'

const VAT_INVOICE_INVOICE_FIELDS = [
  { label: '发票类型', key: 'InvoiceType' },
  { label: '发票名称', key: 'InvoiceTypeOrg' },
  { label: '发票代码', key: 'InvoiceCode' },
  { label: '发票号码', key: 'InvoiceNum' },
  { label: '开票日期', key: 'InvoiceDate' },
  { label: '收款人', key: 'Payee' },
  { label: '复核', key: 'Checker' },
  { label: '开票人', key: 'NoteDrawer' },
]

const VAT_INVOICE_PURCHASER_FIELDS = [
  { label: '名称', key: 'PurchaserName' },
  { label: '纳税人识别号', key: 'PurchaserRegisterNum' },
  { label: '地址、电话', key: 'PurchaserAddress' },
  { label: '开户行及账号', key: 'PurchaserBank' },
]

const VAT_INVOICE_SELLER_FIELDS = [
  { label: '名称', key: 'SellerName' },
  { label: '纳税人识别号', key: 'SellerRegisterNum' },
  { label: '地址、电话', key: 'SellerAddress' },
  { label: '开户行及账号', key: 'SellerBank' },
]

const AIR_TICKET_INVOICE_FIELDS = [
  { label: '发票消费类型', key: 'ServiceType' },
  { label: '姓名', key: 'name' },
  { label: '始发站', key: 'starting_station' },
  { label: '目的站', key: 'destination_station' },
  { label: '航班号', key: 'flight' },
  { label: '日期', key: 'date' },
  { label: '电子客票号码', key: 'ticket_number' },
  { label: '票价', key: 'fare' },
  { label: '民航发展基金/机建费', key: 'dev_fund' },
  { label: '民航发展基金/燃油附加费', key: 'oil_money' },
  { label: '其他税费', key: 'other_tax' },
  { label: '合计金额', key: 'ticket_rates' },
  { label: '填开日期', key: 'start_date' },
  { label: '身份证号', key: 'id_no' },
  { label: '承运人', key: 'carrier' },
  { label: '时间', key: 'time' },
  { label: '填开单位', key: 'issued_by' },
  { label: '印刷序号', key: 'serial_number' },
  { label: '保险费', key: 'insurance' },
  { label: '客票级别', key: 'fare_basis' },
  { label: '座位等级', key: 'class' },
  { label: '销售单位号', key: 'agent_code' },
  { label: '签注', key: 'endorsement' },
  { label: '免费行李', key: 'allow' },
  { label: '验证码', key: 'ck' },
  { label: '客票生效日期', key: 'effective_date' },
  { label: '有效期截止日期', key: 'expiration_date' },
  { label: '发票名称', key: 'invoice_type_org' },
  { label: '国内国际标识', key: 'identification' },
  { label: '开票状态', key: 'invoice_status' },
  { label: '发票号码', key: 'invoice_num' },
  { label: '增值税税率', key: 'commodity_tax_rate' },
  { label: '增值税税额', key: 'commodity_tax' },
  { label: '购买方名称', key: 'purchaser_name' },
  { label: '统一社会信用代码/纳税人识别号', key: 'purchaser_register_num' },
  { label: '提示信息', key: 'tip' },
]

const TAXI_TICKET_INVOICE_FIELDS = [
  { label: '发票消费类型', key: 'ServiceType' },
  { label: '发票代号', key: 'InvoiceCode' },
  { label: '发票号码', key: 'InvoiceNum' },
  { label: '车牌号', key: 'TaxiNum' },
  { label: '日期', key: 'Date' },
  { label: '上下车时间', key: 'Time' },
  { label: '上车时间', key: 'PickupTime' },
  { label: '下车时间', key: 'DropoffTime' },
  { label: '金额', key: 'Fare' },
  { label: '燃油附加费', key: 'FuelOilSurcharge' },
  { label: '叫车服务费', key: 'CallServiceSurcharge' },
  { label: '总金额', key: 'TotalFare' },
  { label: '省', key: 'Location' },
  { label: '市', key: 'City' },
  { label: '单价', key: 'PricePerkm' },
  { label: '里程', key: 'Distance' },
]

const TRAIN_TICKET_INVOICE_FIELDS = [
  { label: '发票消费类型', key: 'ServiceType' },
  { label: '车票号', key: 'ticket_num' },
  { label: '始发站', key: 'starting_station' },
  { label: '车次号', key: 'train_num' },
  { label: '到达站', key: 'destination_station' },
  { label: '出发日期', key: 'date' },
  { label: '车票金额/退票费', key: 'ticket_rates' },
  { label: '席别', key: 'seat_category' },
  { label: '乘客姓名', key: 'name' },
  { label: '身份证号', key: 'ID_card' },
  { label: '序列号', key: 'serial_number' },
  { label: '售站', key: 'sales_station' },
  { label: '时间', key: 'time' },
  { label: '座位号', key: 'seat_num' },
  { label: '候检区', key: 'Waiting_area' },
  { label: '标识', key: 'refund_flag' },
  { label: '发票号码', key: 'invoice_num' },
  { label: '开票日期', key: 'invoice_date' },
  { label: '不含税金额', key: 'fare' },
  { label: '税率', key: 'tax_rate' },
  { label: '税额', key: 'tax' },
  { label: '电子客票号', key: 'elec_ticket_num' },
  { label: '购买方名称', key: 'purchaser_name' },
  { label: '购买方统一社会信用代码', key: 'purchaser_register_num' },
]

const QUOTA_INVOICE_FIELDS = [
  { label: '发票消费类型', key: 'ServiceType' },
  { label: '发票代码', key: 'invoice_code' },
  { label: '发票号码', key: 'invoice_number' },
  { label: '金额', key: 'invoice_rate' },
  { label: '金额小写', key: 'invoice_rate_in_figure' },
  { label: '金额大写', key: 'invoice_rate_in_word' },
  { label: '省', key: 'Province' },
  { label: '市', key: 'City' },
  { label: '发票所在地', key: 'Location' },
  { label: '发票名称', key: 'invoice_type' },
]

const ROLL_NORMAL_INVOICE_FIELDS = [
  { label: '发票名称', key: 'InvoiceType' },
  { label: '发票代码', key: 'InvoiceCode' },
  { label: '发票号码', key: 'InvoiceNum' },
  { label: '机打号码', key: 'MachineNum' },
  { label: '机器编号', key: 'MachineCode' },
  { label: '开票日期', key: 'InvoiceDate' },
  { label: '购方名称', key: 'PurchaserName' },
  { label: '购方纳税人识别号', key: 'PurchaserRegisterNum' },
  { label: '销售方名称', key: 'SellerName' },
  { label: '销售方纳税人识别号', key: 'SellerRegisterNum' },
  { label: '价税合计', key: 'TotalTax' },
  { label: '合计金额(大写)', key: 'AmountInWords' },
]

const PRINTED_INVOICE_FIELDS = [{ label: '发票消费类型', key: 'ServiceType' }]

const BUS_TICKET_INVOICE_FIELDS = [
  { label: '发票消费类型', key: 'ServiceType' },
]

const TOLL_INVOICE_FIELDS = [{ label: '发票消费类型', key: 'ServiceType' }]

const FERRY_TICKET_INVOICE_FIELDS = [
  { label: '发票消费类型', key: 'ServiceType' },
]

const MOTOR_VEHICLE_INVOICE_FIELDS = [
  { label: '开票日期', key: 'date' },
  { label: '发票抬头', key: 'invoice-title' },
  { label: '发票代码', key: 'fapiao-daima' },
  { label: '发票号码', key: 'fapiao-haoma' },
  { label: '机打代码', key: 'printed-daima' },
]

const USED_VEHICLE_INVOICE_FIELDS = [
  { label: '发票消费类型', key: 'ServiceType' },
]

class InvoiceComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      index: this.props.index + 1,
      invoiceInfo: this.props.invoiceInfo,
    }
  }

  render() {
    const info = this.state.invoiceInfo || {}
    const InvoiceNum = getFirstWord(info, 'InvoiceNum', '-')
    const SerialNumber = getFirstWord(info, 'serial_number', '-')
    const InvoiceNumber = getFirstWord(info, 'invoice_number', '-')
    const invoice_num = getFirstWord(info, 'invoice_num', '-')
    const FapiaoHaoma = getFirstWord(info, 'fapiao-haoma', '-')

    const type = getFirstWord(info, 'result_type', '') || info.result_type
    if (
      InvoiceNum === '-' &&
      SerialNumber === '-' &&
      InvoiceNumber === '-' &&
      invoice_num === '-' &&
      FapiaoHaoma === '-'
    ) {
      return (
        <Accordion>
          <Accordion.Panel
            header={this.state.index + '. 无法识别'}
            style={{ padding: 10 }}
          ></Accordion.Panel>
        </Accordion>
      )
    }
    return (
      <Accordion>
        {type === 'vat_invoice' && (
          <Accordion.Panel
            header={
              this.state.index + '. ' +
              getFirstWord(info, 'InvoiceTypeOrg', '—') +
              '【' +
              getFirstWord(info, 'SellerName', '—') +
              '(' +
              getFirstWord(info, 'AmountInFiguers', '—') +
              ')' +
              '】'
            }
            style={{ padding: 10 }}
          >
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {VAT_INVOICE_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>购买方</div>
              {VAT_INVOICE_PURCHASER_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>销售方</div>
              {VAT_INVOICE_SELLER_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
            {info.CommodityName && info.CommodityName.length > 0 ? (
              <section className={styles.vatResultSection}>
                {info.CommodityName.map((itemCommodity, j) => {
                  return (
                    <span>
                      <div className={styles.vatItemHead}>
                        货物或应税劳务、服务
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>名称</span>
                        <span className={styles.vatResultDes}>
                          {info.CommodityName[j].word}
                        </span>
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>规格</span>
                        {info.CommodityType && info.CommodityType[j] ? (
                          <span className={styles.vatResultDes}>
                            {info.CommodityType[j].word}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>单位</span>
                        {info.CommodityUnit && info.CommodityUnit[j] ? (
                          <span className={styles.vatResultDes}>
                            {info.CommodityUnit[j].word}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>数量</span>
                        {info.CommodityNum && info.CommodityNum[j] ? (
                          <span className={styles.vatResultDes}>
                            {info.CommodityNum[j].word}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>单价</span>
                        {info.CommodityPrice && info.CommodityPrice[j] ? (
                          <span className={styles.vatResultDes}>
                            {info.CommodityPrice[j].word}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>金额</span>
                        {info.CommodityAmount && info.CommodityAmount[j] ? (
                          <span className={styles.vatResultDes}>
                            {info.CommodityAmount[j].word}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>税率</span>
                        {info.CommodityTaxRate && info.CommodityTaxRate[j] ? (
                          <span className={styles.vatResultDes}>
                            {info.CommodityTaxRate[j].word}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.vatResultItem}>
                        <span className={styles.vatResultName}>税额</span>
                        {info.CommodityTax && info.CommodityTax[j] ? (
                          <span className={styles.vatResultDes}>
                            {info.CommodityTax[j].word}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    </span>
                  )
                })}
              </section>
            ) : (
              ''
            )}
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>合计</div>
              <div className={styles.vatResultItem}>
                <span className={styles.vatResultName}>金额合计</span>
                <span className={styles.vatResultDes}>
                  {getFirstWord(info, 'TotalAmount', '—')}
                </span>
              </div>
              <div className={styles.vatResultItem}>
                <span className={styles.vatResultName}>税额合计</span>
                <span className={styles.vatResultDes}>
                  {getFirstWord(info, 'TotalTax', '—')}
                </span>
              </div>
              <div className={styles.vatResultItem}>
                <span className={styles.vatResultName}>价税合计(大写)</span>
                <span className={styles.vatResultDes}>
                  {getFirstWord(info, 'AmountInWords', '—')}
                </span>
              </div>
              <div className={styles.vatResultItem}>
                <span className={styles.vatResultName}>价税合计(小写)</span>
                <span className={styles.vatResultDes}>
                  {getFirstWord(info, 'AmountInFiguers', '—')}
                </span>
              </div>
            </section>
          </Accordion.Panel>
        )}
        {type === 'air_ticket' && (
          <Accordion.Panel
            header={
              this.state.index + '. 飞机行程单' +
              '【' +
              getFirstWord(info, 'name', '—') +
              '(' +
              getFirstWord(info, 'ticket_rates', '—') +
              ')' +
              '】'
            }
            style={{ padding: 10 }}
          >
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {AIR_TICKET_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'taxi_receipt' && (
          <Accordion.Panel header={this.state.index + '. 出租车票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {TAXI_TICKET_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'train_ticket' && (
          <Accordion.Panel
            header={
              this.state.index + '. 火车票' +
              '【' +
              getFirstWord(info, 'name', '—') +
              '(' +
              getFirstWord(info, 'ticket_rates', '—') +
              ')' +
              '】'
            }
            style={{ padding: 10 }}
          >
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {TRAIN_TICKET_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'quota_invoice' && (
          <Accordion.Panel header={this.state.index + '. 定额发票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {QUOTA_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'roll_normal_invoice' && (
          <Accordion.Panel header={this.state.index + '. 卷票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {ROLL_NORMAL_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'printed_invoice' && (
          <Accordion.Panel header={this.state.index + '. 机打发票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {PRINTED_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'bus_ticket' && (
          <Accordion.Panel header={this.state.index + '. 汽车票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {BUS_TICKET_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'toll_invoice' && (
          <Accordion.Panel header={this.state.index + '. 过路过桥费'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {TOLL_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'ferry_ticket' && (
          <Accordion.Panel header={this.state.index + '. 船票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {FERRY_TICKET_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'motor_vehicle_invoice' && (
          <Accordion.Panel header={this.state.index + '. 机动车销售发票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {MOTOR_VEHICLE_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
        {type === 'used_vehicle_invoice' && (
          <Accordion.Panel header={this.state.index + '. 二手车销售发票'} style={{ padding: 10 }}>
            <section className={styles.vatResultSection}>
              <div className={styles.vatItemHead}>发票基本信息</div>
              {USED_VEHICLE_INVOICE_FIELDS.map((f) => {
                const value = getFirstWord(info, f.key, '—')
                return (
                  <div key={f.key} className={styles.vatResultItem}>
                    <span className={styles.vatAirResultName}>{f.label}</span>
                    <span className={styles.vatResultDes}>{value}</span>
                  </div>
                )
              })}
            </section>
          </Accordion.Panel>
        )}
      </Accordion>
    )
  }
}

export default InvoiceComponent

